import React, { useContext } from "react";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Clear from "@mui/icons-material/Clear";
import Search from "@mui/icons-material/Search";
import { ShortlistPublisherFilterContext } from "./ShortlistPublisherFilter";

/**
 * @param {object} props
 * @param {string} props.id
 */
export const PublisherNameSearchField = ({ id }) => {
  const { filter, setFilter } = useContext(ShortlistPublisherFilterContext);

  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel htmlFor={id}></InputLabel>
      <OutlinedInput
        fullWidth
        id={id}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        startAdornment={
          <InputAdornment position="start">
            <Search color="action" aria-hidden />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            {filter.length > 0 && (
              <IconButton onClick={() => setFilter("")} aria-label="Clear search">
                <Clear />
              </IconButton>
            )}
          </InputAdornment>
        }
      />
    </FormControl>
  );
};
